var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    fill: "white",
    height: 50,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "it--infrastructure-software_1_",
    d: "M22.5,4.5C22.5,4.776,22.276,5,22,5s-0.5-0.224-0.5-0.5S21.724,4,22,4 S22.5,4.224,22.5,4.5z M20,4c-0.276,0-0.5,0.224-0.5,0.5S19.724,5,20,5s0.5-0.224,0.5-0.5S20.276,4,20,4z M18,4 c-0.276,0-0.5,0.224-0.5,0.5S17.724,5,18,5s0.5-0.224,0.5-0.5S18.276,4,18,4z M30,29.36h-8c-0.199,0-0.36-0.161-0.36-0.36v-4 c0-0.199,0.161-0.36,0.36-0.36h3.64v-3.28h-9.28v3.279H20c0.199,0,0.36,0.161,0.36,0.36v4c0,0.199-0.161,0.36-0.36,0.36h-8 c-0.199,0-0.36-0.161-0.36-0.36v-4c0-0.199,0.161-0.36,0.36-0.36h3.64V21.36H6.36v3.279H10c0.199,0,0.36,0.161,0.36,0.36v4 c0,0.199-0.161,0.36-0.36,0.36H2c-0.199,0-0.36-0.161-0.36-0.36v-4c0-0.199,0.161-0.36,0.36-0.36h3.64V21 c0-0.199,0.161-0.36,0.36-0.36h9.64v-4.28H8c-0.199,0-0.36-0.161-0.36-0.36V3c0-0.199,0.161-0.36,0.36-0.36h16 c0.199,0,0.36,0.161,0.36,0.36v13c0,0.199-0.161,0.36-0.36,0.36h-7.64v4.28H26c0.199,0,0.36,0.161,0.36,0.36v3.64H30 c0.199,0,0.36,0.161,0.36,0.36v4C30.36,29.199,30.199,29.36,30,29.36z M22.36,28.64h7.279v-3.28H22.36V28.64z M12.36,28.64h7.28 v-3.28h-7.28C12.36,25.36,12.36,28.64,12.36,28.64z M2.36,28.64h7.28v-3.28H2.36V28.64z M8.36,15.64h15.28V6.36H8.36V15.64z  M8.36,5.64h15.28V3.36H8.36V5.64z M25,27.36h-2v-0.72h2V27.36z M15,27.36h-2v-0.72h2V27.36z M5,27.36H3v-0.72h2V27.36z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/it.cda9a33d522d7cfcdfa67575481762f3.svg";
export { ForwardRef as ReactComponent };